<script>

    import { onMount } from 'svelte';

    /**
     * @typedef {Object} Props
     * @property {any} [label]
     * @property {boolean} [labelMargin]
     */
    let { label = null, labelMargin = true } = $props();

    let el = $state(null);

    onMount(() => {
        const elTimer = setInterval(() => {
            if (el) {
                clearInterval(elTimer);
                if (label && labelMargin) el.style.marginTop = el.style.marginBottom = '1.5rem'; 
            }
        }, 100);
    });


</script>


<div bind:this={el} class="divider">
    <div></div>
    {#if label}
        <span>{label}</span>
    {/if}
    <div></div>
</div>


<style>
    .divider{
        position:relative;
        width:100%;
        display:flex;
        flex-direction:row;
        align-items:center;
        
    }

    .divider span{
        text-transform: uppercase;
        font-weight:600;
        font-size:0.75rem;
        margin:0 0.5rem;
        color:rgba(255, 255, 255, 0.6);
    }

    .divider div{
        display:block;
        flex-grow:10;
        margin:1rem 0;
        border-top:1px solid #555;
    
    }
</style>